import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class InventoryService {

    nodes = [];
    constructor(public http: HttpClient) {
    }

    getTreeNodes(url) {
        return this.http.get(HttpUtils.getBaseUrl() + url).map((res:any) => this.nodes = res);
    }

    getChildNodes(url) {
        return this.http.get(HttpUtils.getBaseUrl() + url).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/inventory.service.ts